import { Weblog } from '@ks/weblogger/lib/log.hybrid'
import Radar from '@ks/weblogger/lib/plugins/radar'
const isProd = process.env.CODE_ENV === 'production'
const logger = new Weblog(
  {
    env: isProd ? 'production' : 'logger',
    plugins: [
      new Radar({
        // 雷达平台上的唯一标识
        projectId: 'b2d39b520c',
        sampling: 1,
      }),
    ],
  },
  {
    product_name: 'KUAISHOU_VIDEO_EDITOR',
  }
)

export default logger
